import { Grid, Paper, Typography } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { IOrderItem } from '@planning/rt-stores/order/OrderItem'
import { adminActionService } from '@planning/services'
import { IPaginatedStoreWithItems } from '@planning/stores/PaginatedStore'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { RestowListItem } from '../molecules/RestowListItem'
interface Props {
  store: IPaginatedStoreWithItems<IOrderItem>
}

export const RestowListGroup = observer(({ store }: Props) => {
  const { t } = useTranslate()
  const { appViewStore } = usePlanningStore()

  const onDeleteOrder = async (orderId: number) => {
    const isConfirmed = await appViewStore.setOpenConfirmDialog(
      true,
      t('orderWillBeDeletedContinue', 'Order will be deleted. Continue?'),
      t('confirmOrderDelete', 'Confirm order delete'),
      undefined,
    )

    if (!isConfirmed) return

    try {
      await adminActionService.deleteByIds([orderId])
      appViewStore.setShowAlert(
        'success',
        t('successfullyDeletedOrder', 'Successfully deleted order'),
      )
    } catch (e) {
      appViewStore.setShowAlert('error', t('failedToDeleteOrder', 'Failed to delete order'))
    }
  }

  return (
    <Grid container direction='column'>
      <Grid>
        <Typography variant='h3' mb={1}>
          {t('restowList', 'Restow list')}
        </Typography>
      </Grid>
      <Paper elevation={1} style={{ borderRadius: '8px' }}>
        {store.pageItems.length > 0 ? (
          <Grid container direction='column'>
            {store.pageItems.map(item => (
              <Grid key={`restow-item-${item.id}`}>
                <RestowListItem
                  data={item}
                  highlightText={store.filter}
                  onDelete={order => onDeleteOrder(order)}
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography variant='body2' align='center' color='textSecondary' padding={'1rem'}>
            {t('thereAreNoItemsInTheList', 'There are no items in the list')}
          </Typography>
        )}
      </Paper>
    </Grid>
  )
})
